import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-inner-header" }
const _hoisted_2 = { class: "tooltip-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_tooltip = _resolveComponent("f-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.params.displayName), 1),
    _createVNode(_component_f_tooltip, { placement: 'bottom' }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Include_Tenant_Tooltip_Text')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_f_icon, {
          class: "info-icon",
          icon: "info",
          size: 16
        })
      ]),
      _: 1
    })
  ]))
}